module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("wmPRU"))).then(() => parcelRequire('1iHdE'));